import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import {
  Col,
  Container,
  Form,
  Row,
  Button,
  Progress,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Input,
} from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import CommonButton from "../Utils/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import classnames from "classnames";
import { validationSchema } from "./Constant/validationSchema";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import OperatorDetails from "./OperatorDetails";
import { fetchCountries } from "../../slices/customer/countries/thunk";
import { countryOptionss, SGCRoleOptions } from "./Constant/Options";
import { fetchStates } from "../../slices/customer/states/thunk";
import { fetchCities } from "../../slices/customer/cities/thunk";
import {
  OperatorOptionsFields,
  OperatorStatusOptions,
} from "./Constant/Options";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { createOperator } from "../../slices/OperatorManagement/CreateOperator/thunk";
import { editOperator } from "../../slices/OperatorManagement/EditOperator/thunk";
import { fetchOperatorbyId } from "../../slices/OperatorManagement/GetOperatorbyID/thunk";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import moment from "moment";
// import ConfigurationForOperator from "./configurationOperatorNew";
import CommonModal from "../Utils/CommonModal";
import { toggleModal } from "../Customers/constants/TelcoSubmitFunctions";
import { fetchOperatorSpecificConfigurations } from "../../slices/OperatorManagement/GetConfigurationByOperatorId/thunk";
import Stepper from "../Common/Stepper";
import ConfigurationForOperator from "./ConfigurationsOperator";

export default function CreateEditOperators() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState();
  const [isChecked, setIsChecked] = useState(false); // or whatever default
  const [stateData, setStatedata] = useState();
  const [cityData, setCityData] = useState();
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedState, setSelectedState] = useState();
  const [editData, setEditData] = useState(null);
  const isEdit = location.pathname.includes("edit-operator");
  const [logoFile, setLogoFile] = useState(null);
  const [imageOn, setImageOn] = useState(false);
  const fileInputRef = useRef(null);
  const [profileData, setProfileData] = useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [callState, setCallState] = useState(false);
  const [callCity, setCallCity] = useState(false);
  const [progressbarvalue, setprogressbarvalue] = useState(0);
  const [activeTab, setactiveTab] = useState(1);
  const [passedSteps, setPassedSteps] = useState([1]);
  const [finalValues, setFinalValues] = useState({});
  const [defaultConfigurations, setDefaultConfigurations] = useState([]);
  const [finalTemplates, setFinalTemplates] = useState([]);
  const [confirmed, setConfirmed] = useState();
  const [modal, setModal] = useState(false);

  const operatorId = customerIdData();
  function toggleTab(tab, value) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab];

      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab);
        setPassedSteps(modifiedSteps);
      }
    }
    setprogressbarvalue(value);
  }

  useEffect(() => {
    dispatch(fetchCountries(setLoading, setCallState));
  }, [dispatch]);
  const countries = useSelector((state) => state.Countries.countries);
  const countryOptions = countryOptionss(countries?.countries);

  const operatorOptions = [
    {
      name: "Domain",
      value: "Operator",
      options: OperatorOptionsFields,
    },
    {
      name: "country",
      value: "Operator",
      options: countryOptions,
    },
    {
      name: "Status",
      value: "Operator",
      options: OperatorStatusOptions,
    },
    {
      name: "Role",
      value: "Operator",
      options: SGCRoleOptions,
    }
  ];
  useEffect(() => {
    if (callState) {
      dispatch(
        fetchStates(selectedCountry, setCallCity, "isOperator", setStatedata)
      );
    }
  }, [dispatch, isEdit, selectedCountry]);

  useEffect(() => {
    if (callCity) {
      dispatch(
        fetchCities(selectedCountry, selectedState, "isOperator", setCityData)
      );
    }
  }, [dispatch, selectedCountry, selectedState]);

  const initialValues = {
    businessName: "",
    Domain: "",
    state: "",
    city: "",
    zipCode: "",
    endDate: null,
    Address: "",
    Address2: "",
    country: "",
    firstname: "",
    lastname: "",
    username: "",
    phone: "",
    email: "",
    Status: "",
    isSSOUser: false,
    // attributeList: []
  };
  useEffect(() => {
    if (isEdit) {
      dispatch(
        fetchOperatorbyId(
          setLoading,
          operatorId,
          initialValues,
          operatorOptions,
          OperatorStatusOptions,
          setEditData
        )
      );
      dispatch(fetchOperatorSpecificConfigurations(setLoading, operatorId));
    }
  }, [dispatch, setLoading]);
  const operatorData = useSelector(
    (state) => state?.GetOperator?.GetOperatorId ?? null
  );
  const configData = useSelector(
    (state) => state.OperatorSpecificConfig.OperatorSpecificConfiguration
  );
  useEffect(() => {
    if (isEdit && operatorData?.adminDetails?.isSSOUser) {
      setIsChecked(true);
    } else if (isEdit && !operatorData?.adminDetails?.isSSOUser) {
      setIsChecked(false);
    }
  }, [dispatch, isEdit, operatorData]);

  useEffect(() => {
    if (isEdit && editData && editData?.tradingName) {
      let partnerOrCustomer = "Operator";
      dispatch(
        viewDoc(
          setLoading,
          operatorId,
          "logo",
          partnerOrCustomer,
          setProfileData
        )
      );
    }
  }, [dispatch, isEdit, editData]);

  let profile = useSelector((state) => state.ViewDocument.documentView);
  const [update, setUpdate] = useState(!!profile);
  let base64ImageData = [];
  base64ImageData = profile?.filePath;
  let documentName = profile?.documentName;
  useEffect(() => {
    if (isEdit && base64ImageData) {
      setLogoFile(base64ImageData);
    }
    if (!profileData && isEdit) {
      setLogoFile(null);
    }
  }, [isEdit, base64ImageData, profileData]);

  const progressbar = progressbarvalue * 2;

  return (
    <React.Fragment>
      <div
        id="csms"
        className={`page-content bg-white ${
          activeTab === 2 ? "mb-0 pb-0" : ""
        }`}
      >
        <Formik
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={async (values) => {}}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            errors,
            touched,
            values,
            setFieldValue,
            setFieldTouched,
          }) => (
            <Form className="needs-validation" onSubmit={handleSubmit}>
              <Container fluid className="px-0">
                {loading && <Loader />}
                <BreadCrumb
                  title={activeTab === 2
                      ? "Configurations"
                      : isEdit
                      ? "Edit Operator"
                      : "Add operator"}
                  pageTitle={activeTab === 2
                      ? "Configurations"
                      : isEdit
                      ? "Edit Operator"
                      : "Add operator"}
                      moduleTitle={"Operators"}
                />
                <ToastContainer position="top-center" />
                <h5 className="rv-page-title p-0 ps-1 pb-0">{activeTab === 2
                      ? "Configurations"
                      : isEdit
                      ? "Edit Operator"
                      : "Add operator"}</h5>
                <Row>
                  <Col lg={12}>
                    <div className="listingjs-table " id="OperatorList">
                      <Stepper
                        activeTab={activeTab}
                        step1Desc={`Enter Operator Details`}
                        onClickStep1={() => {
                          toggleTab(1, 0);
                        }}
                        step2Desc={`Choose Operator Configuration`}
                        onClickStep2={() => {
                          handleSubmit();
                          if (
                            values?.firstname !== "" &&
                            values?.lastname !== "" &&
                            values?.email !== "" &&
                            values?.username !== "" &&
                            values?.phone !== ""
                          ) {
                            toggleTab(2, 50);
                          }
                        }}
                      />
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId={1}>
                          <OperatorDetails
                            isEdit={isEdit}
                            values={values}
                            errors={errors}
                            touched={touched}
                            setFieldTouched={setFieldTouched}
                            setFieldValue={setFieldValue}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            countries={operatorOptions}
                            setSelectedCountry={setSelectedCountry}
                            setSelectedState={setSelectedState}
                            stateData={stateData}
                            cityData={cityData}
                            operatorData={operatorData}
                            logoFile={logoFile}
                            operatorId={operatorId}
                            imageOn={imageOn}
                            dispatch={dispatch}
                            setLoading={setLoading}
                            profile={profile}
                            documentName={documentName}
                            setLogoFile={setLogoFile}
                            setUpdate={setUpdate}
                            setFileSelected={setFileSelected}
                            fileInputRef={fileInputRef}
                            setImageOn={setImageOn}
                            setIsChecked={setIsChecked}
                            isChecked={isChecked}
                          />

                          <div className="d-flex justify-content-between gap-2 flex-wrap me-2 pe-1 pt-3">
                            <div className="d-flex gap-2 ms-auto">
                              <CommonButton
                                outline={true}
                                className={
                                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                }
                                color={"main-color"}
                                type={"reset"}
                                buttonAction={() =>
                                  navigate("/operator-listing")
                                }
                                buttonText={"Cancel"}
                                icon={
                                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                }
                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                              />

                              <CommonButton
                                color={"main-color"}
                                className={
                                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                }
                                icon={
                                  <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
                                }
                                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                                type={"button"}
                                buttonAction={() => {
                                  handleSubmit();
                                  if (
                                    values?.firstname !== "" &&
                                    values?.lastname !== "" &&
                                    values?.email !== "" &&
                                    values?.username !== "" &&
                                    values?.phone !== ""
                                  ) {
                                    toggleTab(2, 50);
                                  }
                                }}
                                buttonText={"Next"}
                              />
                            </div>
                          </div>
                        </TabPane>
                        <TabPane tabId={2}>
                          <ConfigurationForOperator
                            setFinalValues={setFinalValues}
                            finalValues={finalValues}
                            values={values}
                            configData={configData}
                            isEdit={isEdit}
                            setDefaultConfigurations={setDefaultConfigurations}
                            setFinalTemplates={setFinalTemplates}
                            finalTemplates={finalTemplates}
                            toggleTab={toggleTab}
                            operatorId={operatorId}
                            profile={profile}
                            update={update}
                            setUpdate={setUpdate}
                            logoFile={logoFile}
                            fileSelected={fileSelected}
                            editData={editData}
                            setEditData={setEditData}
                            setFileSelected={setFileSelected}
                            defaultConfigurations={defaultConfigurations}
                            isChecked={isChecked}
                          />
                        </TabPane>
                      </TabContent>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>
      </div>
    </React.Fragment>
  );
}
